<template>
  <div :class="['bto-sb-widget', classes]">
    <div class="bto-sb-widget-title">
      <h3>{{ title }}</h3>
    </div>
    <div class="bto-sb-widget-content">
      <slot></slot>
    </div>
  </div>
</template>
<script>
  export default {
    name: 'ItemList',
    props: {
      title: {
        type: String,
        default: ''
      },
      classes: {
        type: Array,
        default: () => []
      }
    }
  };
</script>